import { updateDeviceAvatarAndAccountName } from "js/Api";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const EditProfilePicModal = (props) => {
  const { visible, user, handleCancel, refreshDeviceInfo } = props;

  const [accountName, setAccountName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImagePreview, setSelectedImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [accountNameError, setAccountNameError] = useState("");

  useEffect(() => {
    if (visible) {
      setAccountName(user?.accountName ?? "");
      setSelectedImagePreview(`data:image/png;base64, ${user?.profilePicture}`);
    }
  }, [visible, user]);

  const resetForm = () => {
    setSelectedImage(null);
    setSelectedImagePreview(null);
    setAccountName("");
  };

  const onAccountNameChange = (e) => {
    setAccountName(e?.target?.value ?? "");
    setAccountNameError("");
  };

  const onImageChangeHandler = (e) => {
    const file = e.target.files[0];
    const errorMsg = "";
    if (!file) {
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split(".").pop();

    if (!allowedExtensions.includes(fileExtension)) {
      errorMsg.textContent = "Only JPG and PNG files are allowed.";
      return;
    }

    if (file.size > maxSize) {
      errorMsg.textContent = "File size must be less than 5 MB.";
      return;
    }

    setSelectedImage(file);
    setSelectedImagePreview(URL.createObjectURL(file));
  };

  const onCancelPressHandler = () => {
    resetForm();
    handleCancel();
  };

  const onSubmitPressHandler = async () => {
    const trimmedName = accountName.trim();

    if (trimmedName.length < 2) {
      setAccountNameError("Account name must be at least 2 characters.");
      return;
    }

    setIsLoading(true);
    const result = await updateDeviceAvatarAndAccountName(
      user.id,
      selectedImage,
      trimmedName
    );
    if (result.success) {
      toast.success(result.message);
      await refreshDeviceInfo();
      onCancelPressHandler();
    } else {
      toast.error(result.error);
    }
    setIsLoading(false);
  };

  if (!visible) {
    return null;
  }
  return (
    <div
      className="modal"
      tabIndex={"-1"}
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content" style={{ minWidth: "500px" }}>
          <div className="modal-header">
            <h1 className="modal-title">Edit Device</h1>
            <button
              className="close-button"
              disabled={isLoading}
              onClick={onCancelPressHandler}
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            <label htmlFor="name" className="form-label">
              Account Name
            </label>
            <input
              className="form-control"
              value={accountName}
              onChange={onAccountNameChange}
            />
            {accountNameError && (
              <div style={{ color: "red", marginTop: "4px" }}>
                {accountNameError}
              </div>
            )}
            <label htmlFor="name" className="form-label mt-3">
              Device Image
            </label>
            {selectedImagePreview ? (
              <div>
                <img
                  className="mt-1 mb-2"
                  src={selectedImagePreview}
                  alt="Preview"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>
            ) : (
              <></>
            )}
            <div>
              <input
                type="file"
                accept="image/*"
                onChange={onImageChangeHandler}
              />
            </div>
            <div className="modal-footer mt-3">
              <input
                type="submit"
                className="btn cur-p btn-light"
                value="Cancel"
                disabled={isLoading}
                onClick={onCancelPressHandler}
              />
              {isLoading ? (
                <button className="btn btn-dark" disabled>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  Saving...
                </button>
              ) : (
                <input
                  type="submit"
                  className="btn cur-p btn-dark"
                  value="Submit"
                  onClick={onSubmitPressHandler}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfilePicModal;
